var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(-44.5 -144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(44.5 144)",
    fill: "#3f5881"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Email-2",
    "data-name": "Email",
    transform: "translate(50.5 152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M18.234,24.1H4.754A2.678,2.678,0,0,1,2.08,21.422V13.354A2.678,2.678,0,0,1,4.754,10.68H18.234a2.678,2.678,0,0,1,2.674,2.674v8.067A2.678,2.678,0,0,1,18.234,24.1ZM4.754,11.624a1.731,1.731,0,0,0-1.731,1.731v8.067a1.731,1.731,0,0,0,1.731,1.731H18.234a1.731,1.731,0,0,0,1.731-1.731V13.354a1.731,1.731,0,0,0-1.731-1.731Z",
    transform: "translate(-2.08 -10.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M12.044,22.935a2.678,2.678,0,0,1-1.614-.538L3.083,16.84a.472.472,0,1,1,.57-.752L11,21.651a1.746,1.746,0,0,0,2.089,0l7.347-5.563a.472.472,0,1,1,.57.752L13.658,22.4A2.678,2.678,0,0,1,12.044,22.935Z",
    transform: "translate(-2.629 -14.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M3.14,35.836a.472.472,0,0,1-.315-.824l5.789-5.163a.472.472,0,1,1,.629.7L3.455,35.717A.459.459,0,0,1,3.14,35.836Zm17.513,0a.459.459,0,0,1-.315-.12l-5.789-5.163a.472.472,0,0,1,.629-.7l5.786,5.163a.472.472,0,0,1-.315.824Z",
    transform: "translate(-2.483 -23.735)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.e995db2924f737182bd0621cb7fae834.svg";
export { ForwardRef as ReactComponent };